<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13 7.375C13.3452 7.375 13.625 7.65482 13.625 8C13.625 8.34518 13.3452 8.625 13 8.625H3C2.65482 8.625 2.375 8.34518 2.375 8C2.375 7.65482 2.65482 7.375 3 7.375H13Z" fill="currentColor"/>
  </svg>
</template>

<script setup lang="ts">

</script>
